import { IDetailsList, IColumn, IContextualMenuProps } from '@fluentui/react';
import { MouseEvent, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * State settings for resizable column Dialog
 */
export const useDetailsListAccessibleColumnResizeState = (
  sortColumn: (col: IColumn) => void
) => {
  const [t] = useTranslation();
  const [contextualMenuProps, setContextualMenuProps] = useState<
    IContextualMenuProps | undefined
  >(undefined);
  const [isDialogHidden, setIsDialogHidden] = useState(true);
  const columnToEdit = useRef<IColumn | null>(null);
  const detailsListRef = useRef<IDetailsList>(null);

  const getContextualMenuProps = (
    ev: MouseEvent<HTMLElement>,
    column: IColumn
  ): IContextualMenuProps => {
    const items = [
      { key: 'resize', text: t('Resize'), onClick: () => resizeColumn(column) },
      { key: 'sort', text: t('Sort'), onClick: () => sortColumn(column) },
    ];

    return {
      items: items,
      target: ev.currentTarget as HTMLElement,
      gapSpace: 10,
      isBeakVisible: true,
      onDismiss: onHideContextualMenu,
    };
  };

  const onHideContextualMenu = useCallback(
    () => setContextualMenuProps(undefined),
    []
  );

  const resizeColumn = (column: IColumn) => {
    columnToEdit.current = column;
    showDialog();
  };

  const hideDialog = () => setIsDialogHidden(true);

  const showDialog = () => setIsDialogHidden(false);

  return {
    isDialogHidden,
    setContextualMenuProps,
    getContextualMenuProps,
    detailsListRef,
    hideDialog,
    contextualMenuProps,
    columnToEdit,
  };
};
